<template>
    <div class="application">
        <Preloader></Preloader>
        <flash-message :outerClass="'notifications'"></flash-message>
        <router-view :key="$route.fullPath"></router-view>
    </div>
</template>

<script>
    /* Components */
    import Preloader from '@components/App/Partials/Preloader'

    /* Logic */
    export default {
        name: 'App',
        components: {
            'Preloader': Preloader
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue